<template>
  <div class="container">
    <div class="turn-view">
      <div class="turn-content">
        <div class="waiting-time-block">
          <div class="waiting-time-block__title">
            {{ $t('experience.turn.waiting-time') }}
          </div>
          <div class="waiting-time-block__text">
            {{ Math.round(turn.averageWaitingTime) }} min
          </div>
        </div>

        <div class="access-code">
          <div class="access-code-head">
            <div class="access-code-head__title">
              {{ $t('experience.turn.access-code.title') }}
            </div>
            <div class="access-code-head__text">
              {{ $t('experience.turn.access-code.text') }}
            </div>
          </div>
          <div class="access-code-content">
            <div class="access-code-content__text">{{ turn.turnCode }}</div>
          </div>
        </div>

        <div v-if="false" class="customer-slider">
          <div class="customer-slider__text">
            <p class="customer-slider__text--title">
              {{ $t('customer-slider.title') }}
            </p>
            <p class="customer-slider__text--subtitle">
              {{ $t('customer-slider.subtitle') }}
            </p>
          </div>
          <CustomSlider :slides="slidesFiltered" />
        </div>
        <div v-if="showMap" class="customer-map">
          <CustomerMap :mapOptions="mapOptions" />
        </div>
        <div
          class="button-movistar button-movistar__primary"
          @click="router.push({ name: 'Home' })"
        >
          {{ $t('experience.turn.return') }}
        </div>
      </div>
    </div>
    <modal :showModal="showModal">
      <template #content>
        <div class="modal-success">
          <IconCircleCheck size="48" color="#019DF4" stroke-width="1" />
          <div class="modal-success__title">
            {{ $t('experience.success.title') }}
          </div>
          <div class="modal-success__subtitle">
            {{ $t('experience.success.subtitle') }}
          </div>
          <div class="modal-success__action">
            <div
              class="button-movistar button-movistar__primary"
              @click="showModal = false"
            >
              {{ $t('experience.success.continue') }}
            </div>
          </div>
        </div>
      </template>
    </modal>
  </div>
</template>
<script setup>
  import router from '@/router'
  import { onMounted, computed, ref } from 'vue'
  import { useStore } from 'vuex'
  import modal from '@/components/movistar/modals/Modal.vue'
  import { IconCircleCheck } from '@tabler/icons-vue'
  import CustomSlider from '@/components/movistar/common/CustomSlider.vue'
  import CustomerMap from '../components/movistar/common/CustomerMap.vue'

  import commonMethods from '@/commonMethods'

  const store = useStore()
  const { translate } = commonMethods()

  let turn = computed(() => store.getters['getTurn'])
  let slides = computed(() => store.state.common.experienceSlides)
  let experience = computed(() => store.getters['getExperience'])
  let experienceType = computed(() => store.state.experience.experienceType)

  let slidesFiltered = ref({})
  let mapFiltered = ref({})
  let showModal = ref(true)
  let showCustomerSlider = ref(false)
  let showMap = ref(false)
  let mapOptions = ref({})

  const goTo = (type) => {
    router.push({ name: type })
  }

  const calculateSlides = async () => {
    let sf = slides.value.filter((slide) => slide.code == 'inmersiveExperience')
    slidesFiltered.value.filter = sf[0].experience
    mapFiltered.value.filter = sf[0].map
    showCustomerSlider.value = true
  }
  onMounted(async () => {
    await calculateSlides()
    checkExperience()
  })

  const checkExperience = () => {
    const locationAttribute = experience.value.attributes?.find(
      (attribute) => attribute.experienceAttributeTypeCode === 'LOCATION'
    )

    mapOptions.value.wait = ''
    mapOptions.value.subtitle = translate(experienceType.value.title)
    mapOptions.value.floor = locationAttribute?.value
    mapOptions.value.image = `maps/${experienceType.value.code}.png`
    mapOptions.value.filter = mapOptions.value
    showMap.value = true
  }
</script>
<style lang="scss">
  @import '@/scss/mixings';
  .head {
    @include d-flex(row, space-between, center, 0px);
    padding: 10px 15px;

    &__back {
      @include d-flex(row, flex-start, center, 10px);
      padding: 1px;
      text-align: center;
      font-size: var(--fs-small);
      font-weight: var(--fw-medium);
      & img {
        width: 24px;
        height: 24px;
      }
    }
  }
  .turn-view {
    @include d-flex(column, flex-start, center);
    gap: 3vh;
    overflow-y: auto;
  }
  .turn-content {
    @include d-flex(column, flex-start, center);
    gap: 3vh;
    width: 100%;
  }
  .waiting-time-block {
    @include d-flex(column, center, center, 20px);
    width: 100%;
    padding: 20px;
    border-radius: 10px;
    background: #e6f5fd;
    overflow: hidden;

    &__title {
      text-align: center;
      font-size: var(--fs-large);
      font-weight: var(--fw-bold);
      line-height: var(--fs-xx-large);
    }

    &__text {
      text-align: center;
      font-size: 3rem;
      font-weight: var(--fw-bold);
      line-height: 3.5rem;
    }
  }

  .access-code {
    @include d-flex(column, center, center, 20px);
    width: 100%;
    padding: 20px;
    overflow: hidden;
    border: 1px #dddddd solid;
    border-radius: 8px;

    &-head {
      @include d-flex(column, flex-start, center, 10px);

      &__title {
        font-size: var(--fs-large);
        font-weight: var(--fw-bold);
        line-height: var(--fs-xx-large);
        word-wrap: break-word;
      }

      &__text {
        font-size: var(--fs-small);
        line-height: var(--fs-x-large);
        word-wrap: break-word;
      }
    }

    &-content {
      @include d-flex(column, flex-start, center, 5px);

      &__text {
        text-align: center;
        font-size: 3rem;
        font-weight: var(--fw-bold);
        line-height: 3.5rem;
        word-wrap: break-word;
      }
    }
  }

  .modal-success {
    @include d-flex(column, flex-start, flex-start, 8px);
    line-height: 24px;

    &__title {
      font-weight: var(--fw-bold);
    }

    &__subtitle {
      font-size: var(--fs-small);
      word-wrap: break-word;
      color: var(--secondary-color);
    }

    &__action {
      padding: 16.11px 0px;
    }
  }
  // .customer-slider {
  //   @include d-flex(column, center, flex-start);
  //   width: 100%;
  //   gap: 2vh;
  //   &__text {
  //     @include d-flex(column, center, flex-start);
  //     gap: 0.5vh;
  //     &--title {
  //       font-family: 'OnAir';
  //       font-size: var(--fs-large);
  //       font-weight: var(--fw-bold);
  //       line-height: 24px;
  //       color: var(--primary-grey-color);
  //     }
  //     &--subtitle {
  //       font-family: 'OnAir';
  //       font-size: var(--fs-small);
  //       line-height: 20px;
  //       color: var(--secondary-grey-color);
  //     }
  //   }
  // }
  .customer-map {
    @include d-flex(column, center, flex-start);
    width: 100%;
  }

  .customer-slider {
    @include d-flex(column, center, flex-start);
    width: 100%;
    gap: 2vh;
    &__text {
      @include d-flex(column, center, flex-start);
      gap: 0.5vh;
      &--title {
        font-family: 'OnAir';
        font-size: var(--fs-large);
        font-weight: var(--fw-bold);
        line-height: 24px;
        color: var(--primary-grey-color);
      }
      &--subtitle {
        font-family: 'OnAir';
        font-size: var(--fs-small);
        line-height: 20px;
        color: var(--secondary-grey-color);
      }
    }
  }
  .customer-map {
    @include d-flex(column, center, flex-start);
    width: 100%;
  }
</style>
